import { Grid, Typography } from '@mui/material';
import CustomTextField from './CustomTextField';

const PostBasicInfo = ({ register, errors }) => {

  return (
    <>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          name="title"
          label="Title"
          required
          register={register}
          errors={errors}
          validation={{ required: 'Title is required' }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTextField
          name="rent"
          label="Rent"
          required
          type="number"
          InputProps={{
            startAdornment: <Typography sx={{ mr: 1, color: "rgba(255,255,255,0.7)" }}>₹</Typography>
          }}
          register={register}
          errors={errors}
          validation={{
            required: 'Rent is required',
            valueAsNumber: true,
            min: { value: 0, message: 'Rent must be a positive number' }
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <CustomTextField
          name="description"
          label="Description"
          required
          register={register}
          errors={errors}
          multiline
          rows={4}
          validation={{ required: 'Description is required' }}
        />
      </Grid>
    </>
  );
};

export default PostBasicInfo;
